import {type AutocompleteProps} from "@mui/material";
import React from "react";
import type {GroupDataDto} from "@/global/api/gen/ts/GroupDataDto";
import {BaseAutocomplete} from "@/global/components/Autocompletes/BaseAutocomplete";
import {apiGetTransportListBySchool} from "@/modules/transports/services/transport.service";
import type {TransportDto} from "@/global/api/gen/ts/TransportDto";

type Props = {
    onChange: (value: TransportDto | null) => void;
    message?: string;
    groupInfo: GroupDataDto,
    label?: string;
    placeholder?: string;
    defaultId?: number | null;
} & Omit<AutocompleteProps<TransportDto, false, boolean, false>, 'options' | 'onChange' | 'renderInput'>

export function TransportsAutocomplete({onChange, groupInfo, defaultId, message, label, placeholder, ...props}: Props) {
    const {data: transportsList, isLoading} = apiGetTransportListBySchool(groupInfo.school_id, {
        limit: 500,
        offset: 0
    });

    return (
        <BaseAutocomplete
            onChange={onChange}
            groupInfo={groupInfo}
            options={transportsList?.items ?? []}
            getOptionLabel={(option) => `${option.brand ?? ''} ${option.model} ${option.plate_number}`}
            isLoading={isLoading}
            {...props}
        />
    );
}